import {
  userIsAdministrator,
  userIsModerator,
} from "../services/user/cognitoService";
import { API } from "aws-amplify";

export function ImportSlugPeople(cognitoUser, personsToImport) {
  const isAdmin = userIsAdministrator(cognitoUser);
  if (!isAdmin) {
    return {
      statusCode: 403,
      body: "You need to be an administrator to run an import",
    };
  }
  bulkImport(personsToImport);
  return { statusCode: 200, body: `Import ran for ${personsToImport.length}` };
}

export function UpdateSlugPerson(cognitoUser, person) {
  const isModerator = userIsModerator(cognitoUser);
  if (!isModerator) {
    return {
      statusCode: 403,
      body: "You need to be a moderator to update Slug People",
    };
  }
  singleUpdate(person);
  return { statusCode: 200, body: `Updated Person ${JSON.stringify(person)}` };
}

const singleUpdate = async (person) => {
  const myAPI = "addslugpersonapi";
  const path = "/updateperson";

  const updatePerson = () => {
    (async function () {
      await API.put(myAPI, path, {
        queryStringParameters: {
          person: JSON.stringify(person),
        },
      });
    })();
  };
  updatePerson();
};

const bulkImport = async (personsToImport) => {
  const myAPI = "addslugpersonapi";
  const path = "/addperson";
  const importPeople = () => {
    (async function () {
      let count = 1;
      for (const person of personsToImport) {
        const personArray = [];
        personArray.push(person);
        await API.put(myAPI, path, {
          queryStringParameters: {
            person: JSON.stringify(personArray),
          },
        });
        count = count + 1;
      }
    })();
  };
  importPeople();
};
